import styled from "@emotion/styled";

export const Container = styled.section`
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0 1rem;
  min-height: 42px;
`;
